import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TextOverflow from './TextOverflow';
import ClientProvider from './client';
export default createDemo(import.meta.url, TextOverflow, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/display/demos/text-overflow/TextOverflow.tsx",
    "fileName": "TextOverflow.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nexport default function TextOverflow() {\n  return (\n    <div style={{ width: 200, whiteSpace: 'nowrap' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        component=\"div\"\n        sx={(theme) => ({\n          textOverflow: 'clip',\n          overflow: 'hidden',\n          my: 2,\n          p: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Lorem Ipsum is simply dummy text\n      </Box>\n      <Box\n        component=\"div\"\n        sx={(theme) => ({\n          textOverflow: 'ellipsis',\n          overflow: 'hidden',\n          my: 2,\n          p: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Lorem Ipsum is simply dummy text\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 54,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nexport default function TextOverflow() {\n  return (\n    <div style={{ width: 200, whiteSpace: 'nowrap' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        component=\"div\"\n        sx={(theme) => ({\n          textOverflow: 'clip',\n          overflow: 'hidden',\n          my: 2,\n          p: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Lorem Ipsum is simply dummy text\n      </Box>\n      <Box\n        component=\"div\"\n        sx={(theme) => ({\n          textOverflow: 'ellipsis',\n          overflow: 'hidden',\n          my: 2,\n          p: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        Lorem Ipsum is simply dummy text\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 54,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
